import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import PATHS from './routesMap'

import SignIn from '../views/auth/SignIn.vue'

const routes = [
  {
    name: 'SignIn',
    path: PATHS.SIGN_IN,
    component: SignIn,
  },
  {
    name: 'MicrosoftCallBack',
    path: PATHS.MICROSOFT_CALLBACK,
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/auth/Callback.vue'),
    meta: {},
  },
  {
    name: 'Home',
    path: PATHS.HOME,
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/home/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'AdminUsers',
    path: PATHS.ADMIN_USERS,
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/Users.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ParamsBoards',
    path: PATHS.PARAMS_BOARDS,
    component: () =>
      import(/* webpackChunkName: "params" */ '../views/params/Boards.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ParamsGroups',
    path: PATHS.PARAMS_GROUPS,
    component: () =>
      import(/* webpackChunkName: "params" */ '../views/params/Groups.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ParamsSurveys',
    path: PATHS.PARAMS_SURVEYS,
    component: () =>
      import(/* webpackChunkName: "params" */ '../views/params/Surveys.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ParamsSurveysDetails',
    path: PATHS.PARAMS_SURVEYS_DETAILS,
    component: () =>
      import(
        /* webpackChunkName: "params" */ '../views/params/SurveysDetails.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ParamsDistributions',
    path: PATHS.PARAMS_DISTRIBUTIONS,
    component: () =>
      import(
        /* webpackChunkName: "params" */ '../views/params/Distributions.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'RegistersTickets',
    path: PATHS.REGISTERS_TICKETS,
    component: () =>
      import(
        /* webpackChunkName: "registers" */ '../views/registers/Tickets.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'RegistersContacts',
    path: PATHS.REGISTERS_CONTACTS,
    component: () =>
      import(
        /* webpackChunkName: "registers" */ '../views/registers/Contacts.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'DistributionsList',
    path: PATHS.DISTRIBUTIONS,
    component: () =>
      import(
        /* webpackChunkName: "distributions" */ '../views/distributions/DistributionsList.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'DistributionsDetails',
    path: PATHS.DISTRIBUTIONS_DETAILS,
    component: () =>
      import(
        /* webpackChunkName: "distributions" */ '../views/distributions/DistributionsDetails.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ReportsGenerals',
    path: PATHS.REPORTS_GENERALS,
    component: () =>
      import(
        /* webpackChunkName: "distributions" */ '../views/reports/ReportGenerals.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ReportsGrip',
    path: PATHS.REPORTS_GRIP,
    component: () =>
      import(
        /* webpackChunkName: "distributions" */ '../views/reports/ReportGrip.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'SurveyUser',
    path: PATHS.SURVEYS_USER,
    component: () =>
      import(
        /* webpackChunkName: "surveys" */ '../views/surveys/SurveyUser.vue'
      ),
    meta: {},
  },
  {
    name: 'Unauthorized',
    path: PATHS.UNAUTHORIZED,
    component: () =>
      import(
        /* webpackChunkName: "unauthorized" */ '../views/unauthorized/Unauthorized.vue'
      ),
  },
  {
    name: 'NotFound',
    path: '/:pathMatch(.*)*',
    component: () =>
      import(
        /* webpackChunkName: "notFound" */ '../views/notFound/NotFound.vue'
      ),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from) => {
  const { isLoggedInEthosNps } = store.getters

  if (isLoggedInEthosNps && to.name === 'SignIn') {
    return { name: 'Home' }
  }

  if (to.meta.requiresAuth) {
    if (!isLoggedInEthosNps && !localStorage.getItem('tokenEthosNps')) {
      return { name: 'SignIn' }
    }
  }
})

router.afterEach(async (to, from) => {
  if (!store.getters.isLoggedInEthosNps && to.meta.requiresAuth) {
    await store.dispatch('logout')
    router.push(PATHS.SIGN_IN)
  }
})

export default router
